var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"backend-div"},[_c('v-sidebar',{class:{'sidebar' : _vm.isShow,'hideSidebar':_vm.isHide}}),_vm._v(" "),_c('div',{class:{'mains':_vm.isShow,'hideMains':_vm.isHide},style:(_vm.fullHeight)},[_c('keep-alive',[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d9001c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backendHome.vue
// module id = null
// module chunks = 